// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uQZ1","colBig":"styles_colBig__2H2SU","colSmall":"styles_colSmall__13Ep5"};